module.exports = __webpack_public_path__ + "static/media/car_bg.2828dd70.png";